export const SMLG_ANALYTICS_CATEGORY = "PmPage";
export const BELTKIT_ANALYTICS_CATEGORY = "BeltPersoPage";
export const SMLG_PRODUCT_TYPE_ANALYTICS = "smallleathergoods";
export const BK_ANALYTICS_PRODUCT_TYPE = "beltkits";
